/**
 *
 * Asynchronously loads the component for GeneralConfirmModal
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
